import {
    getSourceTypeTemplate,
    HistoryField,
} from "@common/constants/history-source-types";
import { fullDateLongFormat } from "@common/helpers/date";
import { pluralizeWithCount } from "@common/helpers/string";
import { Resource } from "@common/types/auditLog";
import { formatDate } from "date-fns";
import { addTimeZoneOffset } from "@helpers/date";
import { HistoryRow } from "../views/historyViewConfig";
import { ActivityDescriptionParts } from "./activityDescriptionTypes";
import { extractReconciliationMetadata } from "./reconciliationMetadata";

export function getReconciliationDescription(resources?: Resource[]): string {
    const metadata = extractReconciliationMetadata(resources);

    if (!metadata) {
        return "Reconciled";
    }

    const { accountName, openingDate, closingDate } = metadata;
    const formattedOpeningDate = openingDate
        ? formatDate(
              addTimeZoneOffset(new Date(openingDate)),
              fullDateLongFormat,
          )
        : "";
    const formattedClosingDate = closingDate
        ? formatDate(
              addTimeZoneOffset(new Date(closingDate)),
              fullDateLongFormat,
          )
        : "";

    return `Reconciled ${accountName ?? ""} for the period ${formattedOpeningDate} - ${formattedClosingDate}`.trim();
}

export function getDiffValueDescriptionParts(
    row: HistoryRow,
): ActivityDescriptionParts {
    const { sourceType, resourceType, count, resources, historyItem, fields } =
        row;
    const template = getSourceTypeTemplate(sourceType, resourceType, fields);
    const verb = template?.verb ?? "Updated";
    const noun = template?.noun ?? "transaction";
    const counter = pluralizeWithCount(noun, count);

    if (
        historyItem.groupByDiffValue?.field ===
        HistoryField.FINANCIAL_ACCOUNT_ID
    ) {
        const metadata = extractReconciliationMetadata(resources);
        if (metadata?.accountName) {
            const formattedOpeningDate = metadata.openingDate
                ? formatDate(
                      addTimeZoneOffset(new Date(metadata.openingDate)),
                      fullDateLongFormat,
                  )
                : "";
            const formattedClosingDate = metadata.closingDate
                ? formatDate(
                      addTimeZoneOffset(new Date(metadata.closingDate)),
                      fullDateLongFormat,
                  )
                : "";
            const dateRange =
                formattedOpeningDate && formattedClosingDate
                    ? `for the period ${formattedOpeningDate} - ${formattedClosingDate}`
                    : "";
            const suffix = dateRange
                ? `in ${metadata.accountName} ${dateRange}`
                : `in ${metadata.accountName}`;
            return { prefix: verb, counter, suffix };
        }
    }

    return { prefix: verb, counter, suffix: "" };
}
